<template>
  <div class="ticket">
    <div class="text-center titles font-weight-bold">
      აირჩიეთ სერვის ცენტრი
    </div>
    <div class="text-center small text-danger" v-if="$v.office.$error">გთხოვთ აირჩიოთ ფილიალი</div>
    <div class="text-center NotoSansGeorgian-Regular">
      <!--      <div class="notification">
              COVID19-თან დაკავშირებული რეგულაციების გამო, ჩვენი დაზღვევის სახლები სამწუხაროდ დროებით არ ფუნქციონირებს. რიგის დაჯავშნა შესაძლებელი იქნება, ფუნქციონირების განახლებისთანავე.
            </div>-->
      <div class="pb-3 pt-2"><span class="info NotoSans-Bold">i</span></div>
      ერთი ჯავშნით შესაძლებელია სერვისის მიღება ერთი დაზღვეულის მიერ ერთ სერვისზე
    </div>
    <div v-for="(branch,index) in branches.branchList" :key="index">
      <div class="card p-3 mt-3">
        <div class="card-title d-flex justify-content-between">
          <div>
            <a :href="branch.addressLine2" target="_blank"><img src="../../assets/img/Icon-location.svg" alt="location"></a>
            <span class="ml-2 NotoSansGeorgian-Bold branch-name">{{ branch.name }} </span>
          </div>
        </div>
        <p class="NotoSansGeorgian-Regular description">{{ branch.addressLine1 }}</p>
        <p class="NotoSansGeorgian-Regular description working-hours">{{ JSON.parse(branch.custom).workingHours }}</p>
      </div>
      <div class="mt-2 card p-2 office " @click="office=branch.publicId">
        <div class="d-flex justify-content-center">
          <b-form-radio name="some-radios"
                        class="NotoSansGeorgian-Bold"
                        v-model="office"
                        checked="office"
                        :ref="'branch'"
                        :value="branch.publicId">
            ფილიალის არჩევა
          </b-form-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  name: "step-2",
  props: ['branches'],
  data() {
    return {
      office: ''
    }
  },
  mounted() {
    this.office = this.branches.branchList[0].publicId;
  },
  validations: {office: {required}}

}
</script>

<style scoped>
.description {
  font-size: 13px;
}

.working-hours {
  color: #6D7271 !important;
}

.branch-name {
  color: #2F3634;
}

.office {
  color: #007A60 !important;
  font-weight: bolder;
}

.titles {
  color: #1A2738;
}

.info {
  color: #fff;
  background-color: #207A62;
  padding: 4px 12px;;
  border-radius: 50%;
}

.NotoSansGeorgian-Regular {
  font-size: 13px;
}

/*.notification {
  position: relative;
  max-width: 100%;
  padding: 22px 22px 22px 44px;
  margin: 0 auto;
  text-align: left;
  background: rgba(240, 78, 65, .1);
  border-radius: 4px;
  z-index: 999999;
}*/

.notification:before {
  content: url("../../assets/img/info-2.svg");
  position: absolute;
  top: 22px;
  left: 15px;

}

/*label.custom-control-label {
  font-family: 'NotoSansGeorgian-Bold', sans-serif!important;
}*/
</style>